import React, { useCallback, useEffect } from "react";
import { Button, Text } from "@vkontakte/vkui";
import styles from "./ServiceAvailabilityMessage.style";
import { connect } from "react-redux";
import {
  clearRegionAndMedicalOrganisation,
  selectMedicalOrganisation,
  startFirstStepLoading,
} from "../../../redux/actions/regionAndMedicalOrganisationActions";
import { updateSessionId } from "../../../redux/actions/userInfoActions";
import { removeErrorTitle } from "../../../helpers/redux";

const ServiceAvailabilityMessage = ({
  error,
  clearMedicalOrganisationSelector,
  dispatchClearRegionAndMedicalOrganisation,
  dispatchStartFirstStepLoading,
}) => {
  useEffect(() => {
    if (error) {
      clearMedicalOrganisationSelector();
    }
  }, [error, clearMedicalOrganisationSelector]);

  /* const getShortErrorMessageFromFull = (fullMessage) => {
        const sentences = fullMessage.split(".");
        return sentences[0]
    }*/

  const refreshPage = useCallback(() => {
    updateSessionId();
    dispatchClearRegionAndMedicalOrganisation();
    dispatchStartFirstStepLoading();
  }, [
    dispatchClearRegionAndMedicalOrganisation,
    dispatchStartFirstStepLoading,
  ]);

  return (
    <>
      {error ? (
        <>
          <Text style={styles.errorMessage}>
            {removeErrorTitle(error.errorDetail.errorMessage)}
          </Text>
          <Button
            size="xl"
            mode="overlay_outline"
            onClick={refreshPage}
            align="center"
            style={styles.refreshButton}
          >
            Обновить страницу
          </Button>
        </>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.regionAndMedicalOrganisation.userChecks.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearMedicalOrganisationSelector: () =>
      dispatch(selectMedicalOrganisation("")),
    dispatchClearRegionAndMedicalOrganisation: () =>
      dispatch(clearRegionAndMedicalOrganisation()),
    dispatchStartFirstStepLoading: () => dispatch(startFirstStepLoading()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceAvailabilityMessage);
